import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { WineModel, WineWidgetModel } from '../../models/WineWidgetModel';
import { Wine } from './Wine';
import { containerVariants, childVariants } from './animation/animation';

interface WinesProps {
  item: WineModel;
  wineList: WineWidgetModel[];
}

/**
 * The FeaturedWines component renders the wine cards with the wine image, title, manufacturer name, price, and discount.
 * @param item - The wine object.
 * @param wineList - The list of wines.
 * @returns a JSX fragment. It is rendering the wine cards with the wine image, title, manufacturer name, price, and discount
 */

export const FeaturedWines = ({ item, wineList }: WinesProps) => {
  const [ref, inView] = useInView({ triggerOnce: true });

  return (
    <motion.div ref={ref} variants={containerVariants} initial='hidden' animate={inView ? 'visible' : 'hidden'} className='w-fit mb-2 flex gap-2'>
      {item.renderedWines > 0 && (
        <>
          {wineList?.slice(0, Number(item.renderedWines)).map((wine: WineWidgetModel, i: number) => {
            return (
              <motion.div key={i} variants={childVariants} className='flex w-[310px] min-[350px]:h-[415px] lg:h-[330px] mx-2 p-0'>
                <Wine key={i} wine={wine} isShowCart={true} />
              </motion.div>
            );
          })}
        </>
      )}
    </motion.div>
  );
};
